import { createSelector } from 'reselect'
import { parse, addDays } from 'date-fns'

const getGarageState = state => state.garage

export const getGarageName = createSelector(
  getGarageState,
  garageState => garageState.pdvDescrizione
)

export const getGarageAddress = createSelector(
  getGarageState,
  garageState => garageState.pdvIndirizzo
)

export const isGarageInitialized = createSelector(
  getGarageState,
  garageState => garageState.isInitialized
)

export const hasGarageInitErrors = createSelector(
  getGarageState,
  garageState => garageState.initError !== null
)

export const getServices = createSelector(
  getGarageState,
  garageState => garageState.services
)

export const getThemeColor = createSelector(
  getGarageState,
  garageState => garageState.coloreBase
)

export const getGarageDateStart = createSelector(
  getGarageState,
  garageState => garageState.finestraAppuntamentiGiorniDa
)

export const getGarageDateEnd = createSelector(
  getGarageState,
  garageState => garageState.finestraAppuntamentiGiorniA
)

export const getGarageDateMax = createSelector(
  getGarageState,
  garageState => garageState.finestraAppuntamentiDataMax
)

export const getGarageDateFirstDay = createSelector(
  getGarageDateStart,
  limitStart => addDays(new Date().setHours(0, 0, 0, 0), limitStart)
)

export const getGarageDateLastDay = createSelector(
  getGarageDateEnd,
  getGarageDateMax,
  (limitEnd, limitMax) =>
    limitEnd !== null
      ? addDays(new Date().setHours(0, 0, 0, 0), limitEnd)
      : parse(limitMax)
)

export const getGarageMandatoryFields = createSelector(
  getGarageState,
  garageState => garageState.campiObbligatori
)

export const getGarageDescription = createSelector(
  getGarageState,
  garageState => garageState.testoServizio
)

export const getGarageTitleSuffix = createSelector(
  getGarageState,
  garageState => garageState.titleSuffix
)

export const hasGaragePDVinTitle = createSelector(
  getGarageState,
  garageState => garageState.showPDVinTitle
)

export const hasGarageCustomFavicon = createSelector(
  getGarageState,
  garageState => garageState.customFavicon
)
